import { Component, OnInit } from '@angular/core';
import { NotificationsSettingsService } from './notifications-settings.service';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { Location } from '@angular/common';
import {ProfileService} from "../profile/profile.service";
import { DashboardService } from '../dashboard/dashboard.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as global from '../global'
import { CompanyService } from 'src/app/services/Modules/company.service';

@Component({
  selector: 'app-notifications-settings',
  templateUrl: './notifications-settings.component.html',
  styleUrls: ['./notifications-settings.component.css']
})

export class NotificationsSettingsComponent implements OnInit {
  
  loggedIn = false;
  notificationOperations:any[] = [];
  currentUser:any;
  userNotificationsState:any = [];
  code: any;
  hideFacilities: boolean = false;
  hideNoteUploading: boolean = false;
  global = global;
  defaultTabIndex: number = 0;
  isBusinessOfficer: boolean = false;
  showMipsTab: boolean = false;
  census_id: any;
  spellCheckOption:Boolean=false;

  constructor(private _notificationsSettingsService:NotificationsSettingsService, 
    private _toastr:ToastrService,
        private _location: Location,
    private companyService: CompanyService,
        private _profileService: ProfileService,
        private _authService: AuthService,
        private dashBoardService: DashboardService,
        private router: Router,
        private route: ActivatedRoute) { 
    // const currentUser = localStorage.getItem('currentUser');
    const currentUser = this._authService.currentUser;
    if(currentUser) {
      // this.currentUser = JSON.parse(currentUser);
      this.currentUser = currentUser;
      if(currentUser.user_type === global.USER_TYPE.BUSINESS_OFFICER){
        this.isBusinessOfficer = true;
      };
    }
    this.loadSpellCheck();
  }
  loadSpellCheck(){
    this.companyService.getSpellCheckOption(this.currentUser?._id).subscribe((res:any)=>{
      if(res.data==true){
        this.spellCheckOption=true;
      }else if(res.data==false){
        this.spellCheckOption=false;
      }else{
        this.spellCheckOption=false;
      }
    })
  }
  ngOnInit() {
    this.initNotificationOperations();
    this.initUserNotificationsState();
    this.getCompanyMipsEnabledStatus(this.currentUser.company_id);
    // console.log(this.route.snapshot.queryParams.code);
    // console.log(this.route.snapshot.params.census);
    let url = this.router.url;
    if (url === '/notifications-settings') {
      this.hideFacilities = true;
      this.hideNoteUploading = true;
    }
    if(this.route.snapshot.params.census) {
      this.defaultTabIndex = 2;
    }
    else{
      this.defaultTabIndex = 0;
    }
    this.code = this.route.snapshot.queryParams.code;
  }

  async setSpellCheck(status){
    this.spellCheckOption=status;
    this.companyService.setSpellCheckOption(null, this.currentUser?._id, this.spellCheckOption).subscribe((res:any)=>{
        this._toastr.success(res.message, "Success");
    })
  }

  async getSpellCheck(){
    return this.spellCheckOption;
  }

  initNotificationOperations() {
    this._notificationsSettingsService.getNotificationOperations().subscribe((response: any) => {
      if(response.status === 200) {
        this.notificationOperations = response.data.array;
      }
    });
  }
  initUserNotificationsState() {
    this._notificationsSettingsService.getUserNotificationsState().subscribe((response: any) => {
      if(response.status === 200) {
        this.userNotificationsState = response.data;
        
      }
    });
  }

  notificationOperationsBy(by:string) {
    return this.notificationOperations.filter(op => op[by] === 'true');
  }

  isNotificationOperationChecked(notification_key, notificationOperationId) {
    if(Array.isArray(this.userNotificationsState[notification_key])) {
      return this.userNotificationsState[notification_key].indexOf(notificationOperationId) >= 0;
    }
    return false;
  }
  getCompanyMipsEnabledStatus(companyId) {
    this.companyService.getCompanyName(companyId).subscribe((response: any) => {
      if (response.status == 200) {
        this.showMipsTab = response.data.enable_company_mips;
      }
    })
  }

  toggleNotificationOperation(notification_key, notificationOperationId) {
    if(!Array.isArray(this.userNotificationsState[notification_key])) {
      this.userNotificationsState[notification_key] = [];
    }
    const i = this.userNotificationsState[notification_key].indexOf(notificationOperationId);
    if(i === -1) {
      this.userNotificationsState[notification_key].push(notificationOperationId);
    } else {
      this.userNotificationsState[notification_key].splice(i,1);
    }
  }

  updateUserNotifcationSettings(notification_key:string) {
    const notification_ids = this.userNotificationsState[notification_key];
    this._notificationsSettingsService.updateUserNotifcationSettings(notification_key, notification_ids).subscribe((response:any) => {
      if(response.status === 200) {
        this._toastr.success(response.message, "Success");
      } else {
        this._toastr.error(response.message, "Error");
      }
    })
  }
  goBack() {
    this._location.back();
  }

  /**
   * general settings
   */
  toggleTwoFactorAuth() {
    this.currentUser.two_factor_auth = !(!!this.currentUser.two_factor_auth);
    this.updateSettings();
  }
  getPreviewNoteSetting() {
    if ( this.currentUser?.other_settings?.preview_note == null ) {
      return true;
    }

    return this.currentUser.other_settings.preview_note;
  }
  getNotePreview(){
    if(this.currentUser?.other_settings){
      return this.currentUser.other_settings.note_sign_confirmation
    }
    else{
      return false
    }
  }
  getDischargePreview(){
    //console.log("this.currentUser?.other_settings",this.currentUser?.other_settings);
    if(this.currentUser?.other_settings){
      return this.currentUser.other_settings.discharge
    }
    else{
      return false
    }
  }
  getUploadPreview(){
    if(this.currentUser?.other_settings){
      return this.currentUser.other_settings.note_upload_confirmation
    }
    else{
      return false
    }
  }
  getShowRRGen(){
    if(this.currentUser?.other_settings){
      return this.currentUser.other_settings.show_rrgen
    }
    else{
      return false
    }
  }
  getShowImeVendor(){
    if(this.currentUser?.other_settings){
      return this.currentUser.other_settings.show_ime_vendor
    }
    else{
      return false
    }
  }
  getShowESign(){
    if(this.currentUser?.other_settings){
      return this.currentUser.other_settings.show_esign
    }
    else{
      return false
    }
  }
  getShowManageCharges(){
    if(this.currentUser?.other_settings){
      return this.currentUser.other_settings.show_manage_charges
    }
    else{
      return false
    }
  }
  getShowTAT(){
    if(this.currentUser?.other_settings){
      return this.currentUser.other_settings.show_tat
    }
    else{
      return false
    }
  }
  changeDischargeStatus(value){
    let oldOtherSettings = this.currentUser.other_settings || {};
    if(oldOtherSettings && oldOtherSettings != null){
      this.currentUser.other_settings.discharge = value;
    }
    else{
      let newOtherSettings = {
        other_settings: {
          discharge: value
        }
      }
      oldOtherSettings = Object.assign(oldOtherSettings, newOtherSettings);
    }
    this._profileService.updateOtherSettings(oldOtherSettings).subscribe((response:any)=>{
      if(response.status == 200){
        this._toastr.success('Settings updated', 'Success');
        this._authService.currentUser = this.currentUser = {
          ...this.currentUser,
          other_settings: oldOtherSettings
        }
      }
    })
  }

  onChangePreviewNote( value ) {
    let oldOtherSettings = this.currentUser.other_settings || {};

    if ( oldOtherSettings && oldOtherSettings != null ) {
      this.currentUser.other_settings.preview_note = value;
    } else {
      let newOtherSettings = {
        other_settings: {
          preview_note: value
        }
      };

      oldOtherSettings = Object.assign( oldOtherSettings, newOtherSettings );
    }

    this._profileService.updateOtherSettings( oldOtherSettings ).subscribe(( response: any ) => {
      if ( response.status === 200 ) {
        this._toastr.success( 'Settings updated', 'Success' );
        this._authService.currentUser = this.currentUser = {
          ...this.currentUser,
          other_settings: oldOtherSettings
        }
      }
    });
  }

  changeSignPreviewStatus(value){
    let oldOtherSettings = this.currentUser.other_settings || {};
    if(oldOtherSettings && oldOtherSettings != null){
      this.currentUser.other_settings.note_sign_confirmation = value;
    }
    else{
      let newOtherSettings = {
        other_settings: {
          note_sign_confirmation: value
        }
      }
      oldOtherSettings = Object.assign(oldOtherSettings, newOtherSettings);
    }
    this._profileService.updateOtherSettings(oldOtherSettings).subscribe((response:any)=>{
      if(response.status == 200){
        this._toastr.success('Settings updated', 'Success');
        this._authService.currentUser = this.currentUser = {
          ...this.currentUser,
          other_settings: oldOtherSettings
        }
      }
    })
  }
  changeUploadPreviewStatus(value){
    let oldOtherSettings = this.currentUser.other_settings || {};
    if(oldOtherSettings && oldOtherSettings != null){
      this.currentUser.other_settings.note_upload_confirmation = value;
    }
    else{
      let newOtherSettings = {
        other_settings: {
          note_upload_confirmation: value
        }
      }
      oldOtherSettings = Object.assign(oldOtherSettings, newOtherSettings);
    }
    this._profileService.updateOtherSettings(oldOtherSettings).subscribe((response:any)=>{
      if(response.status == 200){
        this._toastr.success('Settings updated', 'Success');
        this._authService.currentUser = this.currentUser = {
          ...this.currentUser,
          other_settings: oldOtherSettings
        }
      }
    })
  }
  changeRRGenViewOption(value){
    let oldOtherSettings = this.currentUser.other_settings || {};
    if(oldOtherSettings && oldOtherSettings != null){
      this.currentUser.other_settings.show_rrgen = value;
    }
    else{
      let newOtherSettings = {
        other_settings: {
          show_rrgen: value
        }
      }
      oldOtherSettings = Object.assign(oldOtherSettings, newOtherSettings);
    }
    this._profileService.updateOtherSettings(oldOtherSettings).subscribe((response:any)=>{
      if(response.status == 200){
        this._toastr.success('Settings updated', 'Success');
        this._authService.currentUser = this.currentUser = {
          ...this.currentUser,
          other_settings: oldOtherSettings
        }
      }
    })
  }
  changeImeVendorViewOption(value){
    let oldOtherSettings = this.currentUser.other_settings || {};
    if(oldOtherSettings && oldOtherSettings != null){
      this.currentUser.other_settings.show_ime_vendor = value;
    }
    else{
      let newOtherSettings = {
        other_settings: {
          show_ime_vendor: value
        }
      }
      oldOtherSettings = Object.assign(oldOtherSettings, newOtherSettings);
    }
    this._profileService.updateOtherSettings(oldOtherSettings).subscribe((response:any)=>{
      if(response.status == 200){
        this._toastr.success('Settings updated', 'Success');
        this._authService.currentUser = this.currentUser = {
          ...this.currentUser,
          other_settings: oldOtherSettings
        }
      }
    })
  }
  changeESignViewOption(value){
    let oldOtherSettings = this.currentUser.other_settings || {};
    if(oldOtherSettings && oldOtherSettings != null){
      this.currentUser.other_settings.show_esign = value;
    }
    else{
      let newOtherSettings = {
        other_settings: {
          show_esign: value
        }
      }
      oldOtherSettings = Object.assign(oldOtherSettings, newOtherSettings);
    }
    this._profileService.updateOtherSettings(oldOtherSettings).subscribe((response:any)=>{
      if(response.status == 200){
        this._toastr.success('Settings updated', 'Success');
        this._authService.currentUser = this.currentUser = {
          ...this.currentUser,
          other_settings: oldOtherSettings
        }
      }
    })
  }
  getNonPccFacEmail(){
    if(this.currentUser?.other_settings){
      return this.currentUser.other_settings.non_pcc_email
    }
    else{
      return false
    }
  }
  getPccFacEmail(){
    if(this.currentUser?.other_settings){
      return this.currentUser.other_settings.pcc_email
    }
    else{
      return false
    }
  }
  changeNonPccFacEmailStatus(value){
    let oldOtherSettings = this.currentUser.other_settings || {};
    if(oldOtherSettings && oldOtherSettings != null){
      this.currentUser.other_settings.non_pcc_email = value;
    }
    else{
      let newOtherSettings = {
        other_settings: {
          non_pcc_email: value
        }
      }
      oldOtherSettings = Object.assign(oldOtherSettings, newOtherSettings);
    }
    this._profileService.updateOtherSettings(oldOtherSettings).subscribe((response:any)=>{
      if(response.status == 200){
        this._toastr.success('Settings updated', 'Success');
        this._authService.currentUser = this.currentUser = {
          ...this.currentUser,
          other_settings: oldOtherSettings
        }
      }
    })
  }
  changePccFacEmailStatus(value){
    let oldOtherSettings = this.currentUser.other_settings || {};
    if(oldOtherSettings && oldOtherSettings != null){
      this.currentUser.other_settings.pcc_email = value;
    }
    else{
      let newOtherSettings = {
        other_settings: {
          pcc_email: value
        }
      }
      oldOtherSettings = Object.assign(oldOtherSettings, newOtherSettings);
    }
    this._profileService.updateOtherSettings(oldOtherSettings).subscribe((response:any)=>{
      if(response.status == 200){
        this._toastr.success('Settings updated', 'Success');
        this._authService.currentUser = this.currentUser = {
          ...this.currentUser,
          other_settings: oldOtherSettings
        }
      }
    })
  }
  changeManageChargesOption(value){
    let oldOtherSettings = this.currentUser.other_settings || {};
    if(oldOtherSettings && oldOtherSettings != null){
      this.currentUser.other_settings.show_manage_charges = value;
    }
    else{
      let newOtherSettings = {
        other_settings: {
          show_manage_charges: value
        }
      }
      oldOtherSettings = Object.assign(oldOtherSettings, newOtherSettings);
    }
    this._profileService.updateOtherSettings(oldOtherSettings).subscribe((response:any)=>{
      if(response.status == 200){
        this._toastr.success('Settings updated', 'Success');
        this._authService.currentUser = this.currentUser = {
          ...this.currentUser,
          other_settings: oldOtherSettings
        }
      }
    })
  }
  changeTATOption(value){
    let oldOtherSettings = this.currentUser.other_settings || {};
    if(oldOtherSettings && oldOtherSettings != null){
      this.currentUser.other_settings.show_tat = value;
    }
    else{
      let newOtherSettings = {
        other_settings: {
          show_tat: value
        }
      }
      oldOtherSettings = Object.assign(oldOtherSettings, newOtherSettings);
    }
    this._profileService.updateOtherSettings(oldOtherSettings).subscribe((response:any)=>{
      if(response.status == 200){
        this._toastr.success('Settings updated', 'Success');
        this._authService.currentUser = this.currentUser = {
          ...this.currentUser,
          other_settings: oldOtherSettings
        }
      }
    })
  }

  updateSettings() {
    const item = {
      two_factor_auth: <boolean>null,
      preview_note: <boolean>null,
      note_sign_confirmation: <boolean>null,
      note_upload_confirmation: <boolean>null,
    };

    item.two_factor_auth = this.currentUser.two_factor_auth;
    item.preview_note = this.currentUser.other_settings?.preview_note == null ?
      true :
      this.currentUser.other_settings.preview_note;
    item.note_sign_confirmation =  this.currentUser.other_settings?.note_sign_confirmation? this.currentUser.other_settings.note_sign_confirmation : true;
    item.note_upload_confirmation =  this.currentUser.other_settings?.note_upload_confirmation? this.currentUser.other_settings.note_upload_confirmation : true;



    const infoToast = this._toastr.info('Updating settings...', 'Please wait', {disableTimeOut: true});
    this._profileService.updateSettings(item).subscribe((response: any) => {
      if (response.status === 200) {
        let user = response.data;
        let returned = Object.assign(this.currentUser, user);
        localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
        this._toastr.success(response.message, 'Success');
      } else {
        this._toastr.error(response.message, 'Failed');
      }
    }, (error) => {
      this._toastr.error('Something went wrong, pelase try again', 'Failed');
    }, () => this._toastr.clear(infoToast.toastId));
  }

  updateProfile() {
    const item = {
      email: <string>null,
      usertype: <string>null,
      auth_key: <string>null,
      id: <string>null,
      title: <string>null,
      firstname: <string>null,
      lastname: <string>null,
      mobile: <string>null,
      profile_pic: <string>null,
      email_notification: <string>null,
      push_notification: <string>null,
      email_auth_notification: <string>null,
      sms_auth_notification: <string>null,
      two_factor_auth: <boolean>null,
      preview_note: <boolean>null,
      note_sign_confirmation: <boolean>null,
      note_upload_confirmation: <boolean>null,
    };


    item.email = this.currentUser.email;
    item.auth_key = this.currentUser.auth_key;
    item.usertype = this.currentUser.user_type;
    item.id = this.currentUser._id;
    item.title = this.currentUser.title;
    item.firstname = this.currentUser.first_name;
    item.lastname = this.currentUser.last_name;
    item.email = this.currentUser.email;
    item.mobile = this.currentUser.mobile;
    item.profile_pic = this.currentUser.profile_pic;
    item.email_notification = this.currentUser.email_notification;
    item.push_notification = this.currentUser.push_notification;
    item.email_auth_notification = this.currentUser.email_auth_notification;
    item.sms_auth_notification = this.currentUser.sms_auth_notification;
    item.two_factor_auth = this.currentUser.two_factor_auth;
    item.preview_note = this.currentUser.other_settings?.preview_note == null ?
      true :
      this.currentUser.other_settings.preview_note;
    item.note_sign_confirmation =  this.currentUser.other_settings?.note_sign_confirmation? this.currentUser.other_settings.note_sign_confirmation : true;
    item.note_upload_confirmation =  this.currentUser.other_settings?.note_upload_confirmation? this.currentUser.other_settings.note_upload_confirmation : true;

    const infoToast = this._toastr.info('Updating settings...', 'Please wait', {disableTimeOut: true});
    this._profileService.updateProfile(item).subscribe((response: any) => {
      if (response.status === 200) {
        // update localStorage
        response.data.auth_key = response.data.auth_key + '.WEB';
        localStorage.setItem('currentUser', JSON.stringify(response.data));
        this._toastr.success(response.message, 'Success');
      } else {
        this._toastr.error(response.message, 'Failed');
      }
    }, (error) => {
      this._toastr.error('Something went wrong, pelase try again', 'Failed');
    }, () => this._toastr.clear(infoToast.toastId));

  }
}
